/* The look dialog uses the theme's existing AJAX cart handler. */
(() => {
  if (window.cherryLookReady) return;
  window.cherryLookReady = true;
  let active;

  function updateItem(select) {
    const form = select.closest('form');
    const option = select.selectedOptions[0];
    const button = form.querySelector('[data-add-to-cart]');
    button.hidden = !select.value;
    button.disabled = !select.value || option?.dataset.available !== 'true';
    button.querySelector('[data-add-to-cart-text]').textContent = button.disabled ? 'Sold out' : 'Add to bag';
    if (option?.dataset.price) form.querySelector('[data-look-price]').textContent = option.dataset.price;
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-cherry-shop-look]');
    if (!trigger) return;
    event.preventDefault();
    const section = trigger.closest('[data-cherry-product]');
    const template = section?.querySelector('[data-cherry-look-template]');
    if (!template || active) return;
    const dialog = template.content.querySelector('dialog').cloneNode(true);
    const selectedImage = section.querySelector('[data-product-single-media-slider] .is-selected img');
    const hero = dialog.querySelector('.cherry-look__hero img');
    if (hero && selectedImage) {
      hero.removeAttribute('srcset');
      hero.removeAttribute('data-srcset');
      hero.removeAttribute('data-src');
      hero.classList.remove('lazyload', 'lazyloading');
      hero.src = selectedImage.currentSrc || selectedImage.src;
      hero.alt = selectedImage.alt;
    }
    const primary = dialog.querySelector(`[data-look-product="${section.dataset.productId}"] [data-look-variant]`);
    const hasSize = [...section.querySelectorAll('[data-cherry-size]')].every(select => select.value);
    if (primary && hasSize) primary.value = section.querySelector('[data-product-select]')?.value || primary.value;
    dialog.querySelectorAll('[data-look-variant]').forEach(updateItem);
    dialog.addEventListener('change', event => {
      if (event.target.matches('[data-look-variant]')) updateItem(event.target);
    });
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...dialog.querySelectorAll('a[href], button, select, [tabindex]')]
        .filter(control => control.tabIndex >= 0 && !control.disabled && control.getClientRects().length);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-look-close]')) dialog.close();
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
      const button = event.target.closest('[data-add-to-cart]');
      if (button && !button.form.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
        button.form.reportValidity();
      }
    });
    // Route keyboard form submission through the theme's delegated cart click.
    dialog.addEventListener('submit', event => {
      event.preventDefault();
      const button = event.target.querySelector('[data-add-to-cart]');
      if (button && !button.disabled && !button.hidden) button.click();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('cherry-look-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (trigger.isConnected && !trigger.hidden) trigger.focus({ preventScroll: true });
      dialog.remove();
      active = undefined;
    }, { once: true });
    document.body.append(dialog);
    active = { dialog, section };
    trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('cherry-look-open');
    dialog.showModal();
  });
  document.addEventListener('theme:cart:added', () => active?.dialog.close());
  document.addEventListener('shopify:section:unload', event => {
    if (active && event.target.contains(active.section)) active.dialog.close();
  });
})();
